function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import { fetchJSON, isRequired } from '../utils';
import q from 'query-string';

var getUserPaymentAccounts = function getUserPaymentAccounts(_ref) {
  var merchantId = _ref.merchantId,
      userId = _ref.userId,
      others = _objectWithoutProperties(_ref, ['merchantId', 'userId']);

  return fetchJSON('/user/account/' + merchantId + '/' + userId + '/?' + q.stringify(others));
};

export { getUserPaymentAccounts };
var getUserAvailablePaymentMethods = function getUserAvailablePaymentMethods(_ref2) {
  var merchantId = _ref2.merchantId,
      userId = _ref2.userId,
      others = _objectWithoutProperties(_ref2, ['merchantId', 'userId']);

  return fetchJSON('/user/payment/method/' + merchantId + '/' + userId + '/?' + q.stringify(others));
};

export { getUserAvailablePaymentMethods };
var getAvailablePaymentMethods = function getAvailablePaymentMethods(_ref3) {
  var merchantId = _ref3.merchantId,
      others = _objectWithoutProperties(_ref3, ['merchantId']);

  return fetchJSON('/user/payment/method/' + merchantId + '/?' + q.stringify(others));
};

export { getAvailablePaymentMethods };
var deleteUserPaymentAccount = function deleteUserPaymentAccount(_ref4) {
  var merchantId = _ref4.merchantId,
      userId = _ref4.userId,
      accountId = _ref4.accountId,
      others = _objectWithoutProperties(_ref4, ['merchantId', 'userId', 'accountId']);

  return fetchJSON('/user/account/' + merchantId + '/' + userId + '/' + accountId + '/?' + q.stringify(others), {
    method: 'DELETE'
  });
};

export { deleteUserPaymentAccount };
var getUserOnGoingTransactions = function getUserOnGoingTransactions(_ref5) {
  var merchantId = _ref5.merchantId,
      userId = _ref5.userId,
      others = _objectWithoutProperties(_ref5, ['merchantId', 'userId']);

  return fetchJSON('/user/transaction/' + merchantId + '/' + userId + '/?' + q.stringify(others));
};

export { getUserOnGoingTransactions };
var cancelUserWithdrawal = function cancelUserWithdrawal(_ref6) {
  var merchantId = _ref6.merchantId,
      userId = _ref6.userId,
      transactionId = _ref6.transactionId,
      others = _objectWithoutProperties(_ref6, ['merchantId', 'userId', 'transactionId']);

  return fetchJSON('/user/transaction/' + merchantId + '/' + userId + '/' + transactionId + '/?' + q.stringify(others), {
    method: 'DELETE'
  });
};

export { cancelUserWithdrawal };
var getTransactionStatus = function getTransactionStatus(_ref7) {
  var merchantId = _ref7.merchantId,
      userId = _ref7.userId,
      transactionId = _ref7.transactionId,
      others = _objectWithoutProperties(_ref7, ['merchantId', 'userId', 'transactionId']);

  return fetchJSON('/user/transaction/' + merchantId + '/' + userId + '/' + transactionId + '/status?' + q.stringify(others));
};

export { getTransactionStatus };
export default {
  getUserPaymentAccounts: getUserPaymentAccounts,
  getUserAvailablePaymentMethods: getUserAvailablePaymentMethods,
  deleteUserPaymentAccount: deleteUserPaymentAccount,
  getUserOnGoingTransactions: getUserOnGoingTransactions,
  cancelUserWithdrawal: cancelUserWithdrawal,
  getAvailablePaymentMethods: getAvailablePaymentMethods,
  getTransactionStatus: getTransactionStatus
};